"use strict";
var Observable_1 = require("../../Observable");
var concatMapTo_1 = require("../../operator/concatMapTo");
Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
//# sourceMappingURL=concatMapTo.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/concatMapTo.js
 ** module id = 277
 ** module chunks = 1
 **/